import { toast, ToastOptions } from 'react-toastify';

import { toastSuccessOptions } from '@/utils/toastOptions';

type BmsApiResponseProps = {
  message: string;
  type: string;
};

/**
 * @description ApiType / QueryKey wordt gebruikt voor de response text.
 */
const apiSuccessMap = {
  'post-ddp-notitie': 'Notitie aangemaakt',
  'post-ddp-notitie-status': 'Status aangepast',
  'claim-verwijderen': 'Claim wordt verwijderd',
  versterken: 'Versterking wordt verwerkt',
  wisselen: 'Wissel wordt verwerkt',
  'claim-wijzigen': 'Claim wordt verwerkt',
  'claim-toevoegen': 'Claim wordt verwerkt',
  'wijzigen-inzet': 'Inzet wordt gewijzigd',
  'niet-inzetbaar-vanaf': 'Defect wordt aangemaakt',
  'defect-gereedmelden': 'Defect wordt gereed gemeld',
  'push-melding-verwijderd': 'Push melding verwijderd',
  'push-melding-bijgewerkt': 'Push melding bijgewerkt',
  'push-melding-aangemaakt': 'Push melding aangemaakt',
};

/**
 * @description JsonResponse wordt gebruikt voor de response text.
 */
const apiErrorMap = {
  FUNCTIONELE_FOUT_NOT_FOUND:
    'Mutatie is niet gelukt. (Niet gevonden). Probeer het nog een keer of neem contact op met support.',
  FUNCTIONELE_FOUT_CONFLICT: {
    versterken: 'Versterken is niet gelukt.',
    wisselen: 'Wisselen is niet gelukt.',
    'claim-toevoegen': 'Claim toevoegen is niet gelukt.',
    'claim-verwijderen': 'Claim verwijderen is niet gelukt.',
    'wijzigen-inzet': 'Wijzigen inzet is niet gelukt.',
  },
  TECHNISCHE_FOUT:
    'Mutatie is niet gelukt vanwege een technische fout. Probeer het nog een keer of neem contact op met support.',
  BMS_CONNECTIE_FOUT: 'Er is een BMS connectiefout opgetreden. Neem contact op met support.',
};

export const bmsApiResponseHandler = (json: unknown, apiType: string): BmsApiResponseProps => {
  if (json === 'SUCCES' && apiType in apiSuccessMap)
    return { message: apiSuccessMap[apiType as keyof typeof apiSuccessMap], type: 'success' };

  if (String(json) in apiErrorMap) {
    return {
      message:
        json === 'FUNCTIONELE_FOUT_CONFLICT' && apiType in apiErrorMap[String(json)]
          ? apiErrorMap[String(json) as keyof typeof apiErrorMap][apiType]
          : apiErrorMap[String(json) as keyof typeof apiErrorMap],
      type: 'error',
    };
  }
  return {
    message: 'Er is een onbekende fout opgetreden. Neem contact op met support.',
    type: 'info',
  };
};

export const responseToToastHandler = (
  responseMessage: BmsApiResponseProps,
  options: Partial<ToastOptions<unknown>> = {},
) => {
  if (responseMessage.type === 'success') {
    toast.success(responseMessage.message, { ...toastSuccessOptions, ...options });
  } else if (responseMessage.type === 'error') {
    toast.error(responseMessage.message, { position: 'top-center', ...options });
  } else {
    toast.info(responseMessage.message, { position: 'top-center', ...options });
  }
};
